module.exports = __webpack_public_path__ + "img/supervision_960.89228b7e.webp";